import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

export const REORDER_TAG_PRODUCTS = gql`
  query ReorderTagProducts {
    reorderTagProducts {
      id
      label
      pricePerTag
      value: id
    }
  }
`;

export const CREATE_REORDER_CART = gql`
  mutation CreateReorderCart (
    $dealerId: ID!
    $licenseId: ID!
    $productId: ID!
    $quantity: Int!
  ) {
    createReorderCart (
      dealerId: $dealerId
      licenseId: $licenseId
      productId: $productId
      quantity: $quantity
    ) {
      checkoutUrl
      ${ERRORS}
    }
  }
`;
